export const ALLOCATE_PAYMENT = gql`
    mutation AllocatePayment($input: AllocatePaymentInput) {
        allocatePayment(input: $input) {
            message
        }
    }
`;
